import IPUsageReport from "./IPUsageReport";
export default IPUsageReport;